import axios from 'axios'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
geren:[],
getInfo:[]
}

const mutations = {
GET_INFO(state,data) {
  state.geren = data
},
GET_INFO_ORDER(state,data) {
  state.getInfo = data
}
}

const actions = {
// 获取个人信息
getInfo ({ commit },data) {
  axios.get('/info/?token=' + data).then((response) => {
    // console.log(response)

    commit('GET_INFO',response.data)
  })
},
// 修改密码
passRemove({ commit },data) {
  // console.log(commit)
  commit("GET_REMOVE")
// console.log(data)
return axios.post('/info/',data).then((res) => {
  return res
})
},
PostName({ commit },data) {
  commit('POST_NAME')
  return axios.post('/info/get_nick_name/',data).then((res) => {
    return res
  })
},
//获取订单详情
getInfoOrder({ commit },data) {
  axios.get('info/order/?token=' + data).then((res) => {
    commit('GET_INFO_ORDER',res.data.context)
    // console.log(res.data.context)
  })
}
}

const getters = {
gteNum(state) {
// console.log(state.geren)
// return state.geren.code
let err =  state.geren.errmsg
return err
},
geterr(state) {
  let err2 = state.geren.errmsg
  return err2
}
}

const InfoModule = {
  state,
  mutations,
  actions,
  getters
}

export default InfoModule
